export default __webpack_public_path__ + "static/12_Screenshot-4404f92f4ec78f1eb9a269031b9b13ce.png";